export enum EditToolbarTool {
    DELETE = 'DELETE',
}
